import { Modal, Button, Typography, Image } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./DiscountModal.scss";
import { useRouter } from "next/navigation";
import Cookies from "js-cookie";
import PopupPremier from "../../../assets/images/PremierPopup01.png";
import IslamicPopupDesktop from "../../../assets/images/Pop-up-islamic.png";
import PricingPopup from "../../../assets/images/pricing-popup.png";
import SamsungA24 from "../../../assets/images/samsung-A24.png";
import Link from "next/link";

const DiscountModal = ({ openDiscountModal, showDiscountModal }) => {
  const userType = Cookies.get("user_type");

  const router = useRouter();
  const Text = Typography;

  const handleClick = (type) => {
    sessionStorage.setItem("promoPopup", true);
    if (type === "shop-now") {
      router.push("/electronics");
    } else {
      showDiscountModal(false);
    }
  };

  const getPopupImage = () => {
    switch (userType) {
      case "islamic":
        return window.innerWidth > 768
          ? IslamicPopupDesktop.src
          : IslamicPopupDesktop.src;
      case "premier":
        return PopupPremier.src;
      default:
        return SamsungA24.src;
    }
  };

  const getModalClass = () => {
    switch (userType) {
      case "islamic":
        return "discount-card-modal";
      // islamic-modal
      case "premier":
        return "discount-card-modal premier-modal";
      default:
        return "discount-card-modal";
    }
  };

  return (
    <Modal
      open={openDiscountModal}
      onCancel={() => handleClick("close")}
      footer={null}
      centered
      closable={false}
      bodyStyle={{
        padding: 0,
      }}
      className={getModalClass()}
    >
      <div className="modal-image-container">
        <Link
          href={
            userType === "premier"
              ? "/premier"
              : "/samsung-a24-6gb-ram-128gb-storage-on-easy-installments-with-free-gift-and-1-year-brand-warranty-pta-approved%C2%A0exclusively-available%C2%A0at%C2%A0salamtec-samsung-official%C2%A0online%C2%A0partner"
          }
        >
          <Image
            src={getPopupImage()}
            preview={false}
            width="100%"
            height="100%"
            style={{ objectFit: "cover" }}
          />
        </Link>
        <Button
          type="primary"
          className="discount-modal-button"
          onClick={() => handleClick("close")}
        >
          <CloseOutlined />
        </Button>
      </div>
    </Modal>
  );
};

export default DiscountModal;
